import {theme} from "antd";

const sharedButtonTokens = {
  colorPrimary: "#00CED1",
  primarycolor: "var(--theme-text-on-primary)",
  defaultBg: "transparent",
  defaultHoverBg: "#2C3E50",
  defaultcolor: "var(--theme-text-on-primary)",
  defaultActivecolor: "var(--theme-text-on-primary)",
  defaultHovercolor: "var(--theme-text-on-primary)",
  colorPrimaryHover: "#00CED1",
};

const sharedMenuTokens = {
  lineHeight: 21,
  fontSize: 18,
  fontWeight: 400,
  iconMarginInlineEnd: 22,
  itemBg: "transparent",
  algorithm: true,
  itemHoverColor: "#00CED1",
  itemMarginInline: 15,
  itemHeight: 55,
  itemBorderRadius: 15,
  subMenuItemBorderRadius: 15,
};

export const getDarkAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#00CED1",
    colorBgContainer: "#2C3E50",
    colorPrimaryBg: "#2C3E50",
    colorTextHeading: "var(--text-primary)",
    colorText: "var(--text-primary)",
    colorBgElevated: "#2C3E50",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#2C3E50",
      siderBg: "#2C3E50",
      headerHeight: "100px",
      bodyBg: "#2C3E50",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#2C3E50",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#2C3E50",
      darkPopupBg: "#2C3E50",
      darkItemColor: "var(--text-primary)",
      darkItemSelectedBg: "#2C3E50",
      darkItemHoverBg: "#2C3E50",
      itemColor: "var(--text-primary)",
      darkItemHoverColor: "#00CED1",
      darkItemSelectedColor: "#00CED1",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#2C3E50",
      headerBg: "#2C3E50",
      titleColor: "var(--text-primary)",
      colorIcon: "#CCCCCC",
      colorIconHover: "var(--text-primary)",
    },
    Form: {labelColor: "var(--text-primary)"},
    Input: {
      colorTextPlaceholder: "var(--text-primary)",
      activeBg: "#2C3E50",
    },
    Select: {
      optionActiveBg: "#2C3E50",
      selectorBg: "#2C3E50",
      optionSelectedBg: "#2C3E50",
      optionSelectedColor: "#00CED1",
      optionActiveColor: "#00CED1",
    },
  },
});

export const getLightAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#00CED1",
    colorBgContainer: "#FFFFFF",
    colorPrimaryBg: "#f0f2f5",
    colorTextHeading: "#111827",
    colorText: "#374151",
    colorBgElevated: "#FFFFFF",
    colorBgLayout: "#f0f2f5",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#FFFFFF",
      siderBg: "#FFFFFF",
      headerHeight: "100px",
      bodyBg: "#f0f2f5",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#FFFFFF",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#f0f2f5",
      darkPopupBg: "#f0f2f5",
      darkItemColor: "#374151",
      darkItemSelectedBg: "#eef0f4",
      darkItemHoverBg: "#eef0f4",
      itemColor: "#374151",
      darkItemHoverColor: "#00CED1",
      darkItemSelectedColor: "#00CED1",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#FFFFFF",
      headerBg: "#FFFFFF",
      titleColor: "#111827",
      colorIcon: "#6b7280",
      colorIconHover: "#111827",
    },
    Form: {labelColor: "#374151"},
    Input: {
      colorTextPlaceholder: "#9ca3af",
      activeBg: "#f3f4f6",
    },
    Select: {
      optionActiveBg: "#f3f4f6",
      selectorBg: "#f3f4f6",
      optionSelectedBg: "#eef0f4",
      optionSelectedColor: "#00CED1",
      optionActiveColor: "#00CED1",
    },
  },
});

export const rygTheme = getDarkAntdTheme();
